export default function initMenu(): void {
  let lastScrollTop = 0;
  const mainWrapper = document.getElementById('wrapper') as HTMLElement;
  const autohideElement = document.getElementById('header') as HTMLElement;

  function positionHeader() {
    const scrollTop = window.scrollY;
    if (scrollTop === 0) {
      autohideElement.classList.add('scrolled-top');
      autohideElement.classList.remove('scrolled-down', 'scrolled-up');

      mainWrapper.classList.add('scrolled-top');
      mainWrapper.classList.remove('scrolled-down', 'scrolled-up');
    } else if (scrollTop < lastScrollTop) {
      autohideElement.classList.remove('scrolled-top', 'scrolled-down');
      autohideElement.classList.add('scrolled-up');

      mainWrapper.classList.remove('scrolled-top', 'scrolled-down');
      mainWrapper.classList.add('scrolled-up');
    } else {
      autohideElement.classList.remove('scrolled-top', 'scrolled-up');
      autohideElement.classList.add('scrolled-down');

      mainWrapper.classList.remove('scrolled-top', 'scrolled-up');
      mainWrapper.classList.add('scrolled-down');
    }
    lastScrollTop = scrollTop;
  }

  function setMaxHeights() {
    const megaDrops: NodeListOf<HTMLElement> = document.querySelectorAll('.group\\/mega-drop');
    megaDrops.forEach((megaDrop) => {
      megaDrop.style.setProperty('--megadrop-max-height', `${megaDrop.offsetHeight}px`);
    });
  }

  if (autohideElement && mainWrapper) {
    document.addEventListener('DOMContentLoaded', () => {
      window.addEventListener('scroll', () => {
        positionHeader();
      });
      positionHeader();
      setMaxHeights();
    });
  }
  Alpine.data('header', () => ({
    open: false,
    openDropdownKeyLvl1: '',
    openDropdownKeyLvl2: '',
    trapped: '',
    openAccount: false,
    openLangDropdown: false,
    sectionHover: 0,
    toggleMenuSectionOpen() {
      const button = this.$el;
      const { parentElement } = button;
      const { key, lvl } = button.dataset;
      // close all other open dropdowns
      this.closeAllMenuSections(parentElement, lvl);
      // toggle current dropdown
      if (key) {
        if (lvl === '2') {
          this.openDropdownKeyLvl2 = key;
        } else {
          this.openDropdownKeyLvl1 = key;
        }

        if (window.innerWidth <= 1199) {
          // trap mobile only
          this.trapped = this.openDropdownKeyLvl2 || this.openDropdownKeyLvl1;
        }

        if (key === 'menu-lang') {
          this.openLangDropdown = !this.openLangDropdown;
        }

        if (parentElement) {
          parentElement.classList.toggle('drop-active');
          const buttons = parentElement.getElementsByTagName('button');
          Array.from(buttons).forEach((btn) => {
            // eslint-disable-next-line no-param-reassign
            btn.ariaExpanded = btn.ariaExpanded === 'true' ? 'false' : 'true';
          });
        }
      }
    },
    closeMenuSection() {
      const button = this.$el;
      const { parentElement } = button;
      const { lvl } = button.dataset;
      this.closeAllMenuSections(parentElement, lvl);
    },
    closeAllMenuSections(currentItem?: Element | null, lvl?: string | null) {
      // eslint-disable-next-line @stylistic/max-len
      let navItems: NodeListOf<Element> = document.querySelectorAll('.group\\/nav-item, .group\\/sub-menu');
      if (lvl && lvl > '1') {
        // eslint-disable-next-line @stylistic/max-len
        navItems = document.querySelectorAll(`.group\\/nav-item[data-lvl="${lvl}"], .group\\/sub-menu[data-lvl="${lvl}"]`);
      }
      Array.from(navItems).forEach((item) => {
        if (item !== currentItem) {
          if (lvl === '2') {
            this.openDropdownKeyLvl2 = '';
          } else if (lvl === '1') {
            this.openDropdownKeyLvl1 = '';
          } else {
            this.openDropdownKeyLvl2 = '';
            this.openDropdownKeyLvl1 = '';
          }

          if (window.innerWidth <= 1199) {
            // trap mobile only
            this.trapped = this.openDropdownKeyLvl2 || this.openDropdownKeyLvl1;
          }

          this.openLangDropdown = false;
          item.classList.remove('drop-active');
          const otherButtons = item.getElementsByTagName('button');
          Array.from(otherButtons).forEach((btn) => {
            // eslint-disable-next-line no-param-reassign
            btn.ariaExpanded = 'false';
          });
        }
      });
    },
    toggleSearchOpen() {
      this.openDialog();
      setTimeout(() => {
        document.getElementById('search-input')?.focus();
      }, 400);
    },
    openDialog() {
      this.open = true;
      document.body.style.overflowY = 'hidden';
      document.getElementById('header')?.classList.add('nav-active');
      document.getElementById('main-menu')?.classList.remove('invisible');
    },
    closeDialog() {
      this.open = false;
      document.body.style.overflowY = 'initial';
      document.getElementById('header')?.classList.remove('nav-active');
      document.getElementById('main-menu')?.classList.add('invisible');
      this.closeAllMenuSections();
    },
  }));
}
